module.exports = __webpack_public_path__ + "static/bgnode-54e186d74fde950c9611eaedfdad0de7.jpg";